import { GET_ERROR_LOGS, IS_LOADING } from "./types";

type AppAction = {
  type: "GET_ERROR_LOGS" | "IS_LOADING";
  payload: any;
};

const initialState = {
  errorLogs: [],
  total: 0,
  page: 1,
  totalPages: 0,
  loading: false,
};

export default (state = initialState, action: AppAction) => {
  switch (action.type) {
    case GET_ERROR_LOGS:
      return {
        ...state,
        errorLogs: action.payload.logs,
        total: action.payload.total,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
      };
    case IS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
